import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

// Import images

import WebDev from "../../assets/images/service/web-development.png";
import CCTV from "../../assets/images/service/CCTVCAMERAS.png";
import Repair from "../../assets/images/service/COMPUTERREPAIR.png";
import Network from "../../assets/images/service/NETWORKING.png";
import Hosting from "../../assets/images/service/domainhosting.png";

const services = [
  {
    image: WebDev,
    title: "Website Development",
    description:
      "We design and develop modern, responsive websites that help your business grow online.",
    link: "/website-development"
  },
  {
    image: CCTV,
    title: "CCTV Camera Installation",
    description:
      "Professional CCTV installation services to keep your home and business safe and secure.",
    link: "/cctvcameras"
  },
  {
    image: Repair,
    title: "Computer Repair & Maintenance",
    description:
      "Fast and reliable computer repair, troubleshooting, and maintenance services.",
    link: "/computerrepair"
  },
  {
    image: Network,
    title: "Computer Networking",
    description:
      "Secure and efficient network installation for offices, schools, and organizations.",
    link: "/networking"
  },
  {
    image: Hosting,
    title: "Domain & Hosting",
    description:
      "Register your domain and get reliable hosting services for your website.",
    link: "/domainhosting"
  }
];

const Service = () => {
  return (
    <div className="py-5 bg-light">

      <Container fluid className="px-4">

        <h2 className="text-center mb-5">
          Our Services
        </h2>

        {/* 5 columns in one row */}
        <Row className="row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-4">

          {services.map((service, index) => (
            <Col key={index}>

              <Card className="h-100 shadow-sm service-card">

                {/* Image */}
                <Card.Img
                  variant="top"
                  src={service.image}
                  alt={service.title}
                  className="service-image"
                />

                <Card.Body className="d-flex flex-column">

                  <Card.Title className="service-title">
                    {service.title}
                  </Card.Title>

                  <Card.Text className="service-text">
                    {service.description}
                  </Card.Text>

                  <div className="mt-auto text-end">

                    <Link
                      to={service.link}
                      className="service-arrow"
                    >
                      <span>More </span>
                      <FaArrowRight />
                    </Link>

                  </div>

                </Card.Body>

              </Card>

            </Col>
          ))}

        </Row>

      </Container>

    </div>
  );
};

export default Service;